export default function normalizeErrors(errorData) {
  if (!errorData) return [];

  // Helper function to extract all error messages recursively
  const extractErrors = (obj) => {
    const errors = [];
    for (const [key, value] of Object.entries(obj)) {
      if (Array.isArray(value)) {
        // Only add string values from arrays
        errors.push(...value.filter((item) => typeof item === "string"));
      } else if (typeof value === "object" && value !== null) {
        // Recursively extract from nested objects
        errors.push(...extractErrors(value));
      } else if (typeof value === "string") {
        // Only add if it's not a key name (like 'custom_user')
        if (!key.includes("_") && !key.includes("user")) {
          errors.push(value);
        }
      }
    }
    return errors;
  };

  const fieldErrors = extractErrors(errorData);

  const generalError =
    errorData.message && fieldErrors.length === 0 ? errorData.message : null;

  const allErrors = [...(generalError ? [generalError] : []), ...fieldErrors];

  // Helper function to capitalize first letter
  const capitalizeFirstLetter = (str) => {
    if (typeof str !== "string" || str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  // 4) Normalize each entry into a string and capitalize first letter
  return allErrors
    .filter((err) => {
      // Only include valid string errors, exclude object representations
      if (typeof err !== "string") return false;
      // Exclude strings that look like object representations
      if (err.includes("[object Object]")) return false;
      if (err.includes("[object Array]")) return false;
      // Exclude strings that look like field names or object keys
      if (err.includes("custom_user")) return false;
      if (err.includes("_")) return false;
      return true;
    })
    .map((err) => {
      return capitalizeFirstLetter(err);
    });
}
